import IntlMessages from "@lib/helpers/IntlMessages";
import { StyledNoUserScreen } from "../index.styled";

const ErrorUserScreen = () => {
  return (
    <StyledNoUserScreen>
      {/* <WarningOutlined className="message-icon" /> */}
      <p className="mb-0">
        <IntlMessages id="chatApp.errorUser" />
      </p>
    </StyledNoUserScreen>
  );
};

export default ErrorUserScreen;
